import { apiClient, authClient } from '../shared/api/client';
import { tokenStore } from '../shared/auth/tokenStore';

const BASE_URL = process.env.REACT_APP_ENV === 'production'
  ? { INSIGHTS: 'https://api.vlab.live/v1/dashboard' }
  : { INSIGHTS: 'https://stg-api.vlab.live/v1/dashboard' };

export const insightsApi = {
  getData: async (organizationCode: string, fromDate: string, toDate: string, page: number, pageSize: number, detailsLevel?: string) => {
    let url = `${BASE_URL.INSIGHTS}/insights/${organizationCode}?fromDate=${fromDate}&toDate=${toDate}&page=${page}&pageSize=${pageSize}`;
    if (detailsLevel) {
      url += `&detailsLevel=${detailsLevel}`;
    }
    const { data } = await apiClient.get(url);
    return data;
  },

  getProfile: async () => {
    const profileInfo = tokenStore.getParsed();
    return { response: null, profileInfo };
  },

  getOrganizationsUser: async () => {
    const { data } = await apiClient.get(`${BASE_URL.INSIGHTS}/organization/`);
    return data;
  },

  getRatesByOrganization: async (organizationCode: string, fromDate: string, toDate: string) => {
    const url = `${BASE_URL.INSIGHTS}/insights/${organizationCode}/rates?fromDate=${fromDate}&toDate=${toDate}`;
    const { data } = await apiClient.get(url);
    return data;
  },

  getRateImage: async (rateId: string) => {
    const url = `${BASE_URL.INSIGHTS}/insights/rate/${rateId}`;
    const { data } = await apiClient.get(url, { responseType: 'blob' });
    return data;
  },
};

export const clearCookies = () => {
  tokenStore.clear();
};

export const logout = async () => {
  try {
    await authClient.post('/v1/logout');
  } catch (err) {
    console.error('[logout] remote logout failed:', err);
  } finally {
    tokenStore.clear();
  }
};
